var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92259 11.1414C3.59715 10.8159 3.06951 10.8159 2.74408 11.1414C2.41864 11.4668 2.41864 11.9944 2.74408 12.3199L6.91074 16.4865C7.23618 16.812 7.76382 16.812 8.08926 16.4865L17.2559 7.31987C17.5814 6.99443 17.5814 6.46679 17.2559 6.14136C16.9305 5.81592 16.4028 5.81592 16.0774 6.14136L7.5 14.7188L3.92259 11.1414Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_340_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92259 11.1414C3.59715 10.8159 3.06951 10.8159 2.74408 11.1414C2.41864 11.4668 2.41864 11.9944 2.74408 12.3199L6.91074 16.4865C7.23618 16.812 7.76382 16.812 8.08926 16.4865L17.2559 7.31987C17.5814 6.99443 17.5814 6.46679 17.2559 6.14136C16.9305 5.81592 16.4028 5.81592 16.0774 6.14136L7.5 14.7188L3.92259 11.1414Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_340_595)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.77d31866f9c9d5c273f61fbcbf0fd2f3.svg";
export { ForwardRef as ReactComponent };